import React from 'react';
import { activityTypeEnum } from '../../constants';
import { useUpdateActivityMutation } from '../../hooks/mutations/useActivityMutation';
import { useAuth } from '../../hooks/useAuth';
import { DataItem } from '../../services/apiSLTP/dailyReports/activities';
import { ActivityType } from '../../services/apiSLTP/dailyReports/activityTypes';
import DropDown, { OptionType } from '../ui/DropDown';

interface ActivityNeedsCellProps {
    activity: DataItem;
    activitiesTypes?: ActivityType[];
    disabled?: boolean;
    refetch: () => void;
    isLoading?: boolean;
}

const ActivityNeedsCell: React.FC<ActivityNeedsCellProps> = React.memo(({ activity, activitiesTypes, disabled = false, refetch, isLoading }) => {
    const { mutate: updateActivity } = useUpdateActivityMutation({
        onSuccess: () => {
            refetch();
        },
    });

    const { user } = useAuth();

    const moTruckId = '66b097d4b0a672302822c715';
    const moAmplirollId = '66e14538c7639ac65e2e6763';

    const handleActivityChange = (activityType: OptionType | null) => {
        if (!activityType) return;
        updateActivity({ id: activity._id, body: { activityTypeId: activityType.value } });
    };

    const selectedActivityType = () => {
        return { value: activity.activityTypeId._id, label: activity.activityTypeId.designation };
    };

    return (
        <div>
            {activity.siteId.conducId?._id === user?._id || activity.siteId.assistantConducId?._id === user?._id ? (
                <div style={{ position: 'absolute', left: 0, width: '100%' }}>
                    <DropDown
                        selectedItem={selectedActivityType()}
                        items={
                            activitiesTypes
                                ?.filter((activityType) =>
                                    [moAmplirollId, moTruckId].includes(activity.reportId.userId._id)
                                        ? activityType.type === activityTypeEnum.TRUCK
                                        : activityType.type !== activityTypeEnum.TRUCK
                                )
                                .map((value) => ({ label: value.designation, value: value._id })) || []
                        }
                        inputLabel=""
                        handleChange={(event, value) => handleActivityChange(value)}
                        disabled={disabled}
                        formClassName="pad-0-imp w-200px-imp"
                        loading={isLoading}
                    />
                </div>
            ) : (
                <span>{selectedActivityType().label}</span>
            )}
        </div>
    );
});

export default ActivityNeedsCell;
